import { doc, getDoc, setDoc, collection } from "firebase/firestore";
import {db} from './firebase';
import * as defs from './util/definitions';
import { serverTimestamp } from '@firebase/firestore'
var ls = require('local-storage');


export function checkBuild(go) {
    console.log("checking for new build");
    fetch('/build')
    //fetch('http://localhost:3000/build')
        .then((response) => response.json())
            .then((data) => {
                // is this build differen than our current build?
                if ( ls.get("build") != data ) {
                    ls.set("build", data);
                    go();
                }

            });    
    /*
    let ret = false;
    // get the current build # from firebase
    const docRef = doc(db, "currentbuild", "1");
    const docSnap = getDoc(docRef).then((docSnap) => {
        if (docSnap.exists()) {
            //console.log("Document data:", docSnap.data());
            let build = docSnap.data().build;

            // did the build change?
            if ( build != defs.currentBuild ) {
                console.log("new build available", build);
                go();
            }
        }
    });*/
}

export function checkGame(game, go) {
    console.log("checking for new game");
    let ret = false;
    // get the current game # from firebase
    const docRef = doc(db, "todaygame", "1");
    const docSnap = getDoc(docRef).then((docSnap) => {
        if (docSnap.exists()) {
            //console.log("Document data:", docSnap.data());
            let newGame = docSnap.data().game;

            // did the build change?
            if ( newGame != game ) {
                console.log("new game available", newGame);
                go();
            }
        }
    });
}

export function mobileCheck() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

export function writeFeedback(feedback) {
    feedback.createdAt = serverTimestamp();
    setDoc(doc(collection(db, "gameFeedback")), feedback).then(() => {});

}

const oin = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.,";
const oout ="nopqrstuvwxyzabcdefghijklmNOPQRSTUVWXYZ.,ABCDEFGHIJKLM";

export function obfuscate(s) {
    let ret = "";
    for ( let i=0 ; i<s.length ; i++ ) {
        ret += oout[oin.indexOf(s[i])];
    }
    return ret;
}

export function deObfuscate(s) {
    let ret = "";
    for ( let i=0 ; i<s.length ; i++ )
        ret += oin[oout.indexOf(s[i])];
    return ret;
}

export function CloseX() {
    return (
        <svg version="1.1" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 41.756 41.756">
	        <path d="M27.948,20.878L40.291,8.536c1.953-1.953,1.953-5.119,0-7.071c-1.951-1.952-5.119-1.952-7.07,0L20.878,13.809L8.535,1.465
            c-1.951-1.952-5.119-1.952-7.07,0c-1.953,1.953-1.953,5.119,0,7.071l12.342,12.342L1.465,33.22c-1.953,1.953-1.953,5.119,0,7.071
            C2.44,41.268,3.721,41.755,5,41.755c1.278,0,2.56-0.487,3.535-1.464l12.343-12.342l12.343,12.343
            c0.976,0.977,2.256,1.464,3.535,1.464s2.56-0.487,3.535-1.464c1.953-1.953,1.953-5.119,0-7.071L27.948,20.878z"/>
        </svg>
    );
}

export function Button(props) {
    return (
        <button className="button" style={props.style} disabled={props.disabled} onClick={props.onClick}>{props.children}</button>
    );

}

export function RightArrow() {
    return (
        <svg version="1.1" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 27.965 27.965">
            <path fill="black" d="M23.43,12.929c-0.021-0.021-0.043-0.034-0.064-0.052c-0.025-0.029-0.047-0.061-0.07-0.09
                    l-6.273-6.269c-0.812-0.813-2.099-0.845-2.871-0.071c-0.773,0.772-0.741,2.061,0.071,2.872l3.054,3.056H5.967
                    c-1.096,0-1.984,0.886-1.984,1.979c0.002,1.096,0.889,1.983,1.984,1.983h11.254l-3.041,3.037
                    c-0.824,0.826-0.867,2.122-0.094,2.896c0.775,0.772,2.069,0.731,2.895-0.095l6.354-6.354
                    C24.161,14.997,24.203,13.701,23.43,12.929z"/>
            <path fill="black" d="M13.983,0C6.262,0,0,6.261,0,13.985c0,7.721,6.262,13.979,13.983,13.979
                    c7.724,0,13.982-6.259,13.982-13.979C27.966,6.261,21.707,0,13.983,0z M13.983,26.535c-6.933,0-12.551-5.619-12.551-12.549
                    c0-6.934,5.619-12.551,12.551-12.551s12.551,5.617,12.551,12.551C26.534,20.916,20.915,26.535,13.983,26.535z"/>
        </svg>
    );
}

export function CorrectMedal(props) {
    if ( props.medal == defs.GOLD_LEVEL )
        return (<GoldMedal {...props} />);
    else if ( props.medal == defs.SILVER_LEVEL )
        return (<SilverMedal {...props} />);
    else if ( props.medal == defs.BRONZE_LEVEL )
        return (<BronzeMedal {...props} />);
    else return null;
}

export function GoldMedal(props) {
    return(
        <svg style={props.style} version="1.1" x="0px" y="0px" viewBox="0 0 494.4 494.4">
            <path fill="#DBAB56" d="M247.2,494.4c-132,0-240-108-240-240s108-240,240-240s240,108,240,240S379.2,494.4,247.2,494.4z"/>
            <circle fill="#EFB30C" cx="247.2" cy="240" r="224.8"/>
        	<path fill="#E5A300" d="M48.8,267.2c0-124,100.8-224.8,224.8-224.8c55.2,0,105.6,20,144.8,52.8
		        c-40.8-48.8-102.4-80-171.2-80C123.2,15.2,22.4,116,22.4,240c0,68.8,31.2,130.4,80,172C68.8,372.8,48.8,322.4,48.8,267.2z"/>
	        <path fill="#E5A300" d="M406.4,81.6c88,88,88,230.4,0,318.4S176,488,88,400"/>
            <path fill="#F7D27F" d="M247.2,480c-132,0-240-108-240-240s108-240,240-240s240,108,240,240S379.2,480,247.2,480z
	            M247.2,30.4c-116,0-209.6,94.4-209.6,209.6c0,116,94.4,209.6,209.6,209.6S456.8,355.2,456.8,240S363.2,30.4,247.2,30.4z"/>
            <path fill="#EFC273" d="M487.2,240c0-60.8-22.4-116-59.2-157.6c-42.4-36.8-97.6-59.2-158.4-59.2c-40.8,0-78.4,10.4-112,28
	            c27.2-13.6,57.6-20.8,89.6-20.8c63.2,0,120.8,28.8,159.2,73.6c44.8,38.4,72.8,95.2,72.8,159.2c0,32-7.2,62.4-20,89.6
	            C476.8,319.2,487.2,280.8,487.2,240z"/>
            <path fill="#EAC06C" d="M29.6,263.2c0,60.8,22.4,116,59.2,157.6c42.4,36.8,97.6,59.2,157.6,59.2c40.8,0,78.4-10.4,112-28
	            c-27.2,12.8-57.6,20-89.6,20c-63.2,0-120.8-28.8-159.2-73.6C64.8,360,36,303.2,36,239.2c0-32,7.2-62.4,20-89.6
	            C40,184,29.6,222.4,29.6,263.2z"/>
            <path fill="#E5A300" d="M260.8,88.8c0,7.2-6.4,19.2-13.6,19.2s-13.6-12-13.6-19.2s6.4-13.6,13.6-13.6S260.8,81.6,260.8,88.8z"/>
            <circle fill="#F7D27F" cx="247.2" cy="88.8" r="13.6"/>
            <path fill="#EFC273" d="M256.8,79.2c5.6,5.6,5.6,13.6,0,19.2s-13.6,5.6-19.2,0"/>
            <path fill="#FFE0A1" d="M248.8,22.4c0,0.8-0.8,1.6-1.6,1.6l0,0c-0.8,0-1.6-0.8-1.6-1.6V7.2c0-0.8,0.8-1.6,1.6-1.6l0,0
                c0.8,0,1.6,0.8,1.6,1.6V22.4z"/>
            <path fill="#FFE0A1" d="M248.8,473.6c0,0.8-0.8,1.6-1.6,1.6l0,0c-0.8,0-1.6-0.8-1.6-1.6v-15.2c0-0.8,0.8-1.6,1.6-1.6l0,0
                c0.8,0,1.6,0.8,1.6,1.6V473.6z"/>
            <path fill="#FFE0A1" d="M402.4,88c-0.8,0.8-1.6,0.8-2.4,0l0,0c-0.8-0.8-0.8-1.6,0-2.4l11.2-11.2c0.8-0.8,1.6-0.8,2.4,0l0,0
                c0.8,0.8,0.8,1.6,0,2.4L402.4,88z"/>
            <path fill="#FFE0A1" d="M84,406.4c-0.8,0.8-1.6,0.8-2.4,0l0,0c-0.8-0.8-0.8-1.6,0-2.4l11.2-11.2c0.8-0.8,1.6-0.8,2.4,0l0,0
                c0.8,0.8,0.8,1.6,0,2.4L84,406.4z"/>
            <path fill="#FFE0A1" d="M464.8,242.4c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6H480c0.8,0,1.6,0.8,1.6,1.6l0,0
                c0,0.8-0.8,1.6-1.6,1.6H464.8z"/>
            <path fill="#FFE0A1" d="M14.4,242.4c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6h15.2c0.8-0.8,1.6,0,1.6,0.8l0,0
                c0,0.8-0.8,1.6-1.6,1.6H14.4V242.4z"/>
            <path fill="#FFE0A1" d="M400,396c-0.8-0.8-0.8-1.6,0-2.4l0,0c0.8-0.8,1.6-0.8,2.4,0l11.2,11.2c0.8,0.8,0.8,1.6,0,2.4l0,0
                c-0.8,0.8-1.6,0.8-2.4,0L400,396z"/>
            <path fill="#FFE0A1" d="M80.8,76.8c-0.8-0.8-0.8-1.6,0-2.4l0,0c0.8-0.8,1.6-0.8,2.4,0l11.2,11.2c0.8,0.8,0.8,1.6,0,2.4l0,0
                c-0.8,0.8-1.6,0.8-2.4,0L80.8,76.8z"/>
            <path fill="#FFE0A1" d="M140,51.2c0.8,0.8,0,2.4-0.8,2.4l0,0c-0.8,0.8-2.4,0-2.4-0.8l-8-13.6c-0.8-0.8,0-2.4,0.8-2.4l0,0
                c0.8-0.8,2.4,0,2.4,0.8L140,51.2z"/>
            <path fill="#FFE0A1" d="M365.6,441.6c0.8,0.8,0,2.4-0.8,2.4l0,0c-0.8,0.8-2.4,0-2.4-0.8l-8-13.6c-0.8-0.8,0-2.4,0.8-2.4l0,0
                c0.8-0.8,2.4,0,2.4,0.8L365.6,441.6z"/>
            <path fill="#FFE0A1" d="M305.6,30.4c0,0.8-1.6,1.6-2.4,1.6l0,0c-0.8,0-1.6-1.6-1.6-2.4l4-15.2c0-0.8,1.6-1.6,2.4-1.6l0,0
                c0.8,0,1.6,1.6,1.6,2.4L305.6,30.4z"/>
            <path fill="#FFE0A1" d="M188.8,465.6c0,0.8-1.6,1.6-2.4,1.6l0,0c-0.8,0-1.6-1.6-1.6-2.4l4-15.2c0-0.8,1.6-1.6,2.4-1.6l0,0
                c0.8,0,1.6,1.6,1.6,2.4L188.8,465.6z"/>
            <path fill="#FFE0A1" d="M436.8,132.8c-0.8,0.8-2.4,0-2.4-0.8l0,0c-0.8-0.8,0-2.4,0.8-2.4l13.6-8c0.8-0.8,2.4,0,2.4,0.8l0,0
                c0.8,0.8,0,2.4-0.8,2.4L436.8,132.8z"/>
            <path fill="#FFE0A1" d="M46.4,358.4c-0.8,0.8-2.4,0-2.4-0.8l0,0c-0.8-0.8,0-2.4,0.8-2.4l13.6-8c0.8-0.8,2.4,0,2.4,0.8l0,0
                c0.8,0.8,0,2.4-0.8,2.4L46.4,358.4z"/>
            <path fill="#FFE0A1" d="M456.8,298.4c-0.8,0-1.6-1.6-1.6-2.4l0,0c0-0.8,1.6-1.6,2.4-1.6l15.2,4c0.8,0,1.6,1.6,1.6,2.4l0,0
                c0,0.8-1.6,1.6-2.4,1.6L456.8,298.4z"/>
            <path fill="#FFE0A1" d="M21.6,181.6c-0.8,0-1.6-1.6-1.6-2.4l0,0c0-0.8,1.6-1.6,2.4-1.6l15.2,4c0.8,0,1.6,1.6,1.6,2.4l0,0
                c0,0.8-1.6,1.6-2.4,1.6L21.6,181.6z"/>
            <path fill="#FFE0A1" d="M60,129.6c0.8,0.8,1.6,1.6,0.8,2.4l0,0c-0.8,0.8-1.6,1.6-2.4,0.8l-13.6-8c-0.8-0.8-1.6-1.6-0.8-2.4
                l0,0c0.8-0.8,1.6-1.6,2.4-0.8L60,129.6z"/>
            <path fill="#FFE0A1" d="M450.4,355.2c0.8,0.8,1.6,1.6,0.8,2.4l0,0c-0.8,0.8-1.6,1.6-2.4,0.8l-13.6-8
                c-0.8-0.8-1.6-1.6-0.8-2.4l0,0c0.8-0.8,1.6-1.6,2.4-0.8L450.4,355.2z"/>
            <path fill="#FFE0A1" d="M192.8,29.6c0,0.8,0,2.4-1.6,2.4l0,0c-0.8,0-2.4,0-2.4-1.6l-4-15.2c0-0.8,0-2.4,1.6-2.4l0,0
                c0.8,0,2.4,0,2.4,1.6L192.8,29.6z"/>
            <path fill="#FFE0A1" d="M309.6,464.8c0,0.8,0,2.4-1.6,2.4l0,0c-0.8,0-2.4,0-2.4-1.6l-4-15.2c0-0.8,0-2.4,1.6-2.4l0,0
                c0.8,0,2.4,0,2.4,1.6L309.6,464.8z"/>
            <path fill="#FFE0A1" d="M357.6,52.8c-0.8,0.8-1.6,1.6-2.4,0.8l0,0c-0.8-0.8-1.6-1.6-0.8-2.4l8-13.6c0.8-0.8,1.6-1.6,2.4-0.8
                l0,0c0.8,0.8,1.6,1.6,0.8,2.4L357.6,52.8z"/>
            <path fill="#FFE0A1" d="M132,443.2c-0.8,0.8-1.6,1.6-2.4,0.8l0,0c-0.8-0.8-1.6-1.6-0.8-2.4l8-13.6c0.8-0.8,1.6-1.6,2.4-0.8
                l0,0c0.8,0.8,1.6,1.6,0.8,2.4L132,443.2z"/>
            <path fill="#FFE0A1" d="M457.6,185.6c-0.8,0-2.4,0-2.4-1.6l0,0c0-0.8,0-2.4,1.6-2.4l15.2-4c0.8,0,2.4,0,2.4,1.6l0,0
                c0,0.8,0,2.4-1.6,2.4L457.6,185.6z"/>
            <path fill="#FFE0A1" d="M22.4,302.4c-0.8,0-2.4,0-2.4-1.6l0,0c0-0.8,0-2.4,1.6-2.4l15.2-4c0.8,0,2.4,0,2.4,1.6l0,0
                c0,0.8,0,2.4-1.6,2.4L22.4,302.4z"/>
            <path fill="#FFE0A1" d="M266.4,145.6h-21.6c-2.4,0-4.8,0.8-7.2,1.6L196,169.6c-6.4,3.2-9.6,10.4-8,17.6l4.8,20
                c0.8,4.8,4,8.8,8.8,10.4c4,1.6,9.6,1.6,13.6-0.8l11.2-5.6V352c0,8.8,7.2,15.2,15.2,15.2h24.8c8.8,0,15.2-7.2,15.2-15.2V160.8
                C281.6,152.8,274.4,145.6,266.4,145.6z"/>
            <path fill="#F7D27F" d="M225.6,261.6v89.6c0,8.8,7.2,15.2,15.2,15.2h24.8c8.8,0,15.2-7.2,15.2-15.2V205.6L225.6,261.6z"/>
        </svg>
    );
}

export function SilverMedal(props) {
    return(
        <svg style={props.style} version="1.1" x="0px" y="0px" viewBox="0 0 494.4 494.4" >
            <path fill="#90AEAF" d="M247.2,494.4c-132,0-240-108-240-240s108-240,240-240s240,108,240,240S379.2,494.4,247.2,494.4z"/>
            <circle fill="#7D979E" cx="247.2" cy="240" r="224.8"/>
            <path fill="#688389" d="M48.8,267.2c0-124,100.8-224.8,224.8-224.8c55.2,0,105.6,20,144.8,52.8
                    c-40.8-48.8-102.4-80-171.2-80C123.2,15.2,22.4,116,22.4,240c0,68.8,31.2,130.4,80,172C68.8,372.8,48.8,322.4,48.8,267.2z"/>
            <path fill="#688389" d="M406.4,81.6c88,88,88,230.4,0,318.4S176,488,88,400"/>
            <path fill="#B6CBCE" d="M247.2,480c-132,0-240-108-240-240s108-240,240-240s240,108,240,240S379.2,480,247.2,480z
                M247.2,30.4c-116,0-209.6,94.4-209.6,209.6c0,116,94.4,209.6,209.6,209.6S456.8,355.2,456.8,240S363.2,30.4,247.2,30.4z"/>
                <path fill="#A3BFC1" d="M487.2,240c0-60.8-22.4-116-59.2-157.6c-42.4-36.8-97.6-59.2-158.4-59.2c-40.8,0-78.4,10.4-112,28
                    c27.2-13.6,57.6-20.8,89.6-20.8c63.2,0,120.8,28.8,159.2,73.6c44.8,38.4,72.8,95.2,72.8,159.2c0,32-7.2,62.4-20,89.6
                    C476.8,319.2,487.2,280.8,487.2,240z"/>
                <path fill="#A3BFC1" d="M29.6,263.2c0,60.8,22.4,116,59.2,157.6c42.4,36.8,97.6,59.2,157.6,59.2c40.8,0,78.4-10.4,112-28
                    c-27.2,12.8-57.6,20-89.6,20c-63.2,0-120.8-28.8-159.2-73.6C64.8,360,36,303.2,36,239.2c0-32,7.2-62.4,20-89.6
                    C40,184,29.6,222.4,29.6,263.2z"/>
                <path fill="#C7E0E2" d="M248.8,22.4c0,0.8-0.8,1.6-1.6,1.6l0,0c-0.8,0-1.6-0.8-1.6-1.6V7.2c0-0.8,0.8-1.6,1.6-1.6l0,0
                    c0.8,0,1.6,0.8,1.6,1.6V22.4z"/>
                <path fill="#C7E0E2" d="M248.8,473.6c0,0.8-0.8,1.6-1.6,1.6l0,0c-0.8,0-1.6-0.8-1.6-1.6v-15.2c0-0.8,0.8-1.6,1.6-1.6l0,0
                    c0.8,0,1.6,0.8,1.6,1.6V473.6z"/>
                <path fill="#C7E0E2" d="M402.4,88c-0.8,0.8-1.6,0.8-2.4,0l0,0c-0.8-0.8-0.8-1.6,0-2.4l11.2-11.2c0.8-0.8,1.6-0.8,2.4,0l0,0
                    c0.8,0.8,0.8,1.6,0,2.4L402.4,88z"/>
                <path fill="#C7E0E2" d="M84,406.4c-0.8,0.8-1.6,0.8-2.4,0l0,0c-0.8-0.8-0.8-1.6,0-2.4l11.2-11.2c0.8-0.8,1.6-0.8,2.4,0l0,0
                    c0.8,0.8,0.8,1.6,0,2.4L84,406.4z"/>
                <path fill="#C7E0E2" d="M464.8,242.4c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6H480c0.8,0,1.6,0.8,1.6,1.6l0,0
                    c0,0.8-0.8,1.6-1.6,1.6H464.8z"/>
                <path fill="#C7E0E2" d="M14.4,242.4c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6h15.2c0.8-0.8,1.6,0,1.6,0.8l0,0
                    c0,0.8-0.8,1.6-1.6,1.6H14.4V242.4z"/>
                <path fill="#C7E0E2" d="M400,396c-0.8-0.8-0.8-1.6,0-2.4l0,0c0.8-0.8,1.6-0.8,2.4,0l11.2,11.2c0.8,0.8,0.8,1.6,0,2.4l0,0
                    c-0.8,0.8-1.6,0.8-2.4,0L400,396z"/>
                <path fill="#C7E0E2" d="M80.8,76.8c-0.8-0.8-0.8-1.6,0-2.4l0,0c0.8-0.8,1.6-0.8,2.4,0l11.2,11.2c0.8,0.8,0.8,1.6,0,2.4l0,0
                    c-0.8,0.8-1.6,0.8-2.4,0L80.8,76.8z"/>
                <path fill="#C7E0E2" d="M140,51.2c0.8,0.8,0,2.4-0.8,2.4l0,0c-0.8,0.8-2.4,0-2.4-0.8l-8-13.6c-0.8-0.8,0-2.4,0.8-2.4l0,0
                    c0.8-0.8,2.4,0,2.4,0.8L140,51.2z"/>
                <path fill="#C7E0E2" d="M365.6,441.6c0.8,0.8,0,2.4-0.8,2.4l0,0c-0.8,0.8-2.4,0-2.4-0.8l-8-13.6c-0.8-0.8,0-2.4,0.8-2.4l0,0
                    c0.8-0.8,2.4,0,2.4,0.8L365.6,441.6z"/>
                <path fill="#C7E0E2" d="M305.6,30.4c0,0.8-1.6,1.6-2.4,1.6l0,0c-0.8,0-1.6-1.6-1.6-2.4l4-15.2c0-0.8,1.6-1.6,2.4-1.6l0,0
                    c0.8,0,1.6,1.6,1.6,2.4L305.6,30.4z"/>
                <path fill="#C7E0E2" d="M188.8,465.6c0,0.8-1.6,1.6-2.4,1.6l0,0c-0.8,0-1.6-1.6-1.6-2.4l4-15.2c0-0.8,1.6-1.6,2.4-1.6l0,0
                    c0.8,0,1.6,1.6,1.6,2.4L188.8,465.6z"/>
                <path fill="#C7E0E2" d="M436.8,132.8c-0.8,0.8-2.4,0-2.4-0.8l0,0c-0.8-0.8,0-2.4,0.8-2.4l13.6-8c0.8-0.8,2.4,0,2.4,0.8l0,0
                    c0.8,0.8,0,2.4-0.8,2.4L436.8,132.8z"/>
                <path fill="#C7E0E2" d="M46.4,358.4c-0.8,0.8-2.4,0-2.4-0.8l0,0c-0.8-0.8,0-2.4,0.8-2.4l13.6-8c0.8-0.8,2.4,0,2.4,0.8l0,0
                    c0.8,0.8,0,2.4-0.8,2.4L46.4,358.4z"/>
                <path fill="#C7E0E2" d="M456.8,298.4c-0.8,0-1.6-1.6-1.6-2.4l0,0c0-0.8,1.6-1.6,2.4-1.6l15.2,4c0.8,0,1.6,1.6,1.6,2.4l0,0
                    c0,0.8-1.6,1.6-2.4,1.6L456.8,298.4z"/>
                <path fill="#C7E0E2" d="M21.6,181.6c-0.8,0-1.6-1.6-1.6-2.4l0,0c0-0.8,1.6-1.6,2.4-1.6l15.2,4c0.8,0,1.6,1.6,1.6,2.4l0,0
                    c0,0.8-1.6,1.6-2.4,1.6L21.6,181.6z"/>
                <path fill="#C7E0E2" d="M60,129.6c0.8,0.8,1.6,1.6,0.8,2.4l0,0c-0.8,0.8-1.6,1.6-2.4,0.8l-13.6-8c-0.8-0.8-1.6-1.6-0.8-2.4
                    l0,0c0.8-0.8,1.6-1.6,2.4-0.8L60,129.6z"/>
                <path fill="#C7E0E2" d="M450.4,355.2c0.8,0.8,1.6,1.6,0.8,2.4l0,0c-0.8,0.8-1.6,1.6-2.4,0.8l-13.6-8
                    c-0.8-0.8-1.6-1.6-0.8-2.4l0,0c0.8-0.8,1.6-1.6,2.4-0.8L450.4,355.2z"/>
                <path fill="#C7E0E2" d="M192.8,29.6c0,0.8,0,2.4-1.6,2.4l0,0c-0.8,0-2.4,0-2.4-1.6l-4-15.2c0-0.8,0-2.4,1.6-2.4l0,0
                    c0.8,0,2.4,0,2.4,1.6L192.8,29.6z"/>
                <path fill="#C7E0E2" d="M309.6,464.8c0,0.8,0,2.4-1.6,2.4l0,0c-0.8,0-2.4,0-2.4-1.6l-4-15.2c0-0.8,0-2.4,1.6-2.4l0,0
                    c0.8,0,2.4,0,2.4,1.6L309.6,464.8z"/>
                <path fill="#C7E0E2" d="M357.6,52.8c-0.8,0.8-1.6,1.6-2.4,0.8l0,0c-0.8-0.8-1.6-1.6-0.8-2.4l8-13.6c0.8-0.8,1.6-1.6,2.4-0.8
                    l0,0c0.8,0.8,1.6,1.6,0.8,2.4L357.6,52.8z"/>
                <path fill="#C7E0E2" d="M132,443.2c-0.8,0.8-1.6,1.6-2.4,0.8l0,0c-0.8-0.8-1.6-1.6-0.8-2.4l8-13.6c0.8-0.8,1.6-1.6,2.4-0.8
                    l0,0c0.8,0.8,1.6,1.6,0.8,2.4L132,443.2z"/>
                <path fill="#C7E0E2" d="M457.6,185.6c-0.8,0-2.4,0-2.4-1.6l0,0c0-0.8,0-2.4,1.6-2.4l15.2-4c0.8,0,2.4,0,2.4,1.6l0,0
                    c0,0.8,0,2.4-1.6,2.4L457.6,185.6z"/>
                <path fill="#C7E0E2" d="M22.4,302.4c-0.8,0-2.4,0-2.4-1.6l0,0c0-0.8,0-2.4,1.6-2.4l15.2-4c0.8,0,2.4,0,2.4,1.6l0,0
                    c0,0.8,0,2.4-1.6,2.4L22.4,302.4z"/>
                <path fill="#C7E0E2" d="M307.2,315.2H260c33.6-33.6,58.4-64,58.4-101.6c0-34.4-23.2-71.2-73.6-71.2c-24,0-46.4,8-64,23.2
                    c-5.6,4.8-7.2,12-4,18.4l8,18.4c1.6,4,5.6,8,10.4,8.8c4.8,0.8,9.6,0,13.6-3.2c5.6-4.8,16.8-12.8,30.4-12.8c16,0,22.4,6.4,22.4,21.6
                    c0,22.4-20,44.8-66.4,88.8l-20,20c-3.2,3.2-4.8,7.2-4.8,11.2v16c0,8.8,7.2,15.2,15.2,15.2h121.6c8.8,0,15.2-7.2,15.2-15.2v-21.6
                    C322.4,321.6,315.2,315.2,307.2,315.2z"/>
            <path fill="#B6CBCE" d="M194.4,304.8l-20,20c-3.2,3.2-4.8,7.2-4.8,11.2v16c0,8.8,7.2,15.2,15.2,15.2h121.6
                c8.8,0,15.2-7.2,15.2-15.2v-21.6c0-8.8-7.2-15.2-15.2-15.2h-47.2c33.6-33.6,58.4-64,58.4-101.6c0-12-3.2-24-8.8-34.4l-50.4,50.4
                C252.8,247.2,232.8,268.8,194.4,304.8z"/>
            <path fill="#688389" d="M232.8,88.8c0,7.2-6.4,19.2-13.6,19.2c-7.2,0-13.6-12-13.6-19.2s6.4-13.6,13.6-13.6
                C226.4,75.2,232.8,81.6,232.8,88.8z"/>
            <circle fill="#B6CBCE" cx="219.2" cy="88.8" r="13.6"/>
            <path fill="#A3BFC1" d="M228.8,79.2c5.6,5.6,5.6,13.6,0,19.2s-13.6,5.6-19.2,0"/>
            <path fill="#688389" d="M288.8,88.8c0,7.2-6.4,19.2-13.6,19.2s-13.6-12-13.6-19.2s6.4-13.6,13.6-13.6
                C282.4,75.2,288.8,81.6,288.8,88.8z"/>
            <circle fill="#B6CBCE" cx="275.2" cy="88.8" r="13.6"/>
            <path fill="#A3BFC1" d="M284.8,79.2c5.6,5.6,5.6,13.6,0,19.2s-13.6,5.6-19.2,0"/>
        </svg>

    );
}

export function BronzeMedal(props) {
    return(
        <svg style={props.style} version="1.1" x="0px" y="0px" viewBox="0 0 494.4 494.4" >
            <path fill="#D89E77" d="M247.2,494.4c-132,0-240-108-240-240s108-240,240-240s240,108,240,240S379.2,494.4,247.2,494.4z"/>
            <circle fill="#D88B56" cx="247.2" cy="240" r="224.8"/>
                <path fill="#CC7E48" d="M48.8,267.2c0-124,100.8-224.8,224.8-224.8c55.2,0,105.6,20,144.8,52.8
                    c-40.8-48.8-102.4-80-171.2-80C123.2,15.2,22.4,116,22.4,240c0,68.8,31.2,130.4,80,172C68.8,372.8,48.8,322.4,48.8,267.2z"/>
                <path fill="#CC7E48" d="M406.4,81.6c88,88,88,230.4,0,318.4S176,488,88,400"/>
            <path fill="#F7C6A4" d="M247.2,480c-132,0-240-108-240-240s108-240,240-240s240,108,240,240S379.2,480,247.2,480z
                M247.2,30.4c-116,0-209.6,94.4-209.6,209.6c0,116,94.4,209.6,209.6,209.6S456.8,355.2,456.8,240S363.2,30.4,247.2,30.4z"/>
                <path fill="#E8B18B" d="M487.2,240c0-60.8-22.4-116-59.2-157.6c-42.4-36.8-97.6-59.2-158.4-59.2c-40.8,0-78.4,10.4-112,28
                    c27.2-13.6,57.6-20.8,89.6-20.8c63.2,0,120.8,28.8,159.2,73.6c44.8,38.4,72.8,95.2,72.8,159.2c0,32-7.2,62.4-20,89.6
                    C476.8,319.2,487.2,280.8,487.2,240z"/>
                <path fill="#E8B18B" d="M29.6,263.2c0,60.8,22.4,116,59.2,157.6c42.4,36.8,97.6,59.2,157.6,59.2c40.8,0,78.4-10.4,112-28
                    c-27.2,12.8-57.6,20-89.6,20c-63.2,0-120.8-28.8-159.2-73.6C64.8,360,36,303.2,36,239.2c0-32,7.2-62.4,20-89.6
                    C40,184,29.6,222.4,29.6,263.2z"/>
                <path fill="#FFDCC5" d="M248.8,22.4c0,0.8-0.8,1.6-1.6,1.6l0,0c-0.8,0-1.6-0.8-1.6-1.6V7.2c0-0.8,0.8-1.6,1.6-1.6l0,0
                    c0.8,0,1.6,0.8,1.6,1.6V22.4z"/>
                <path fill="#FFDCC5" d="M248.8,473.6c0,0.8-0.8,1.6-1.6,1.6l0,0c-0.8,0-1.6-0.8-1.6-1.6v-15.2c0-0.8,0.8-1.6,1.6-1.6l0,0
                    c0.8,0,1.6,0.8,1.6,1.6V473.6z"/>
                <path fill="#FFDCC5" d="M402.4,88c-0.8,0.8-1.6,0.8-2.4,0l0,0c-0.8-0.8-0.8-1.6,0-2.4l11.2-11.2c0.8-0.8,1.6-0.8,2.4,0l0,0
                    c0.8,0.8,0.8,1.6,0,2.4L402.4,88z"/>
                <path fill="#FFDCC5" d="M84,406.4c-0.8,0.8-1.6,0.8-2.4,0l0,0c-0.8-0.8-0.8-1.6,0-2.4l11.2-11.2c0.8-0.8,1.6-0.8,2.4,0l0,0
                    c0.8,0.8,0.8,1.6,0,2.4L84,406.4z"/>
                <path fill="#FFDCC5" d="M464.8,242.4c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6H480c0.8,0,1.6,0.8,1.6,1.6l0,0
                    c0,0.8-0.8,1.6-1.6,1.6H464.8z"/>
                <path fill="#FFDCC5" d="M14.4,242.4c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6h15.2c0.8-0.8,1.6,0,1.6,0.8l0,0
                    c0,0.8-0.8,1.6-1.6,1.6H14.4V242.4z"/>
                <path fill="#FFDCC5" d="M400,396c-0.8-0.8-0.8-1.6,0-2.4l0,0c0.8-0.8,1.6-0.8,2.4,0l11.2,11.2c0.8,0.8,0.8,1.6,0,2.4l0,0
                    c-0.8,0.8-1.6,0.8-2.4,0L400,396z"/>
                <path fill="#FFDCC5" d="M80.8,76.8c-0.8-0.8-0.8-1.6,0-2.4l0,0c0.8-0.8,1.6-0.8,2.4,0l11.2,11.2c0.8,0.8,0.8,1.6,0,2.4l0,0
                    c-0.8,0.8-1.6,0.8-2.4,0L80.8,76.8z"/>
                <path fill="#FFDCC5" d="M140,51.2c0.8,0.8,0,2.4-0.8,2.4l0,0c-0.8,0.8-2.4,0-2.4-0.8l-8-13.6c-0.8-0.8,0-2.4,0.8-2.4l0,0
                    c0.8-0.8,2.4,0,2.4,0.8L140,51.2z"/>
                <path fill="#FFDCC5" d="M365.6,441.6c0.8,0.8,0,2.4-0.8,2.4l0,0c-0.8,0.8-2.4,0-2.4-0.8l-8-13.6c-0.8-0.8,0-2.4,0.8-2.4l0,0
                    c0.8-0.8,2.4,0,2.4,0.8L365.6,441.6z"/>
                <path fill="#FFDCC5" d="M305.6,30.4c0,0.8-1.6,1.6-2.4,1.6l0,0c-0.8,0-1.6-1.6-1.6-2.4l4-15.2c0-0.8,1.6-1.6,2.4-1.6l0,0
                    c0.8,0,1.6,1.6,1.6,2.4L305.6,30.4z"/>
                <path fill="#FFDCC5" d="M188.8,465.6c0,0.8-1.6,1.6-2.4,1.6l0,0c-0.8,0-1.6-1.6-1.6-2.4l4-15.2c0-0.8,1.6-1.6,2.4-1.6l0,0
                    c0.8,0,1.6,1.6,1.6,2.4L188.8,465.6z"/>
                <path fill="#FFDCC5" d="M436.8,132.8c-0.8,0.8-2.4,0-2.4-0.8l0,0c-0.8-0.8,0-2.4,0.8-2.4l13.6-8c0.8-0.8,2.4,0,2.4,0.8l0,0
                    c0.8,0.8,0,2.4-0.8,2.4L436.8,132.8z"/>
                <path fill="#FFDCC5" d="M46.4,358.4c-0.8,0.8-2.4,0-2.4-0.8l0,0c-0.8-0.8,0-2.4,0.8-2.4l13.6-8c0.8-0.8,2.4,0,2.4,0.8l0,0
                    c0.8,0.8,0,2.4-0.8,2.4L46.4,358.4z"/>
                <path fill="#FFDCC5" d="M456.8,298.4c-0.8,0-1.6-1.6-1.6-2.4l0,0c0-0.8,1.6-1.6,2.4-1.6l15.2,4c0.8,0,1.6,1.6,1.6,2.4l0,0
                    c0,0.8-1.6,1.6-2.4,1.6L456.8,298.4z"/>
                <path fill="#FFDCC5" d="M21.6,181.6c-0.8,0-1.6-1.6-1.6-2.4l0,0c0-0.8,1.6-1.6,2.4-1.6l15.2,4c0.8,0,1.6,1.6,1.6,2.4l0,0
                    c0,0.8-1.6,1.6-2.4,1.6L21.6,181.6z"/>
                <path fill="#FFDCC5" d="M60,129.6c0.8,0.8,1.6,1.6,0.8,2.4l0,0c-0.8,0.8-1.6,1.6-2.4,0.8l-13.6-8c-0.8-0.8-1.6-1.6-0.8-2.4
                    l0,0c0.8-0.8,1.6-1.6,2.4-0.8L60,129.6z"/>
                <path fill="#FFDCC5" d="M450.4,355.2c0.8,0.8,1.6,1.6,0.8,2.4l0,0c-0.8,0.8-1.6,1.6-2.4,0.8l-13.6-8
                    c-0.8-0.8-1.6-1.6-0.8-2.4l0,0c0.8-0.8,1.6-1.6,2.4-0.8L450.4,355.2z"/>
                <path fill="#FFDCC5" d="M192.8,29.6c0,0.8,0,2.4-1.6,2.4l0,0c-0.8,0-2.4,0-2.4-1.6l-4-15.2c0-0.8,0-2.4,1.6-2.4l0,0
                    c0.8,0,2.4,0,2.4,1.6L192.8,29.6z"/>
                <path fill="#FFDCC5" d="M309.6,464.8c0,0.8,0,2.4-1.6,2.4l0,0c-0.8,0-2.4,0-2.4-1.6l-4-15.2c0-0.8,0-2.4,1.6-2.4l0,0
                    c0.8,0,2.4,0,2.4,1.6L309.6,464.8z"/>
                <path fill="#FFDCC5" d="M357.6,52.8c-0.8,0.8-1.6,1.6-2.4,0.8l0,0c-0.8-0.8-1.6-1.6-0.8-2.4l8-13.6c0.8-0.8,1.6-1.6,2.4-0.8
                    l0,0c0.8,0.8,1.6,1.6,0.8,2.4L357.6,52.8z"/>
                <path fill="#FFDCC5" d="M132,443.2c-0.8,0.8-1.6,1.6-2.4,0.8l0,0c-0.8-0.8-1.6-1.6-0.8-2.4l8-13.6c0.8-0.8,1.6-1.6,2.4-0.8
                    l0,0c0.8,0.8,1.6,1.6,0.8,2.4L132,443.2z"/>
                <path fill="#FFDCC5" d="M457.6,185.6c-0.8,0-2.4,0-2.4-1.6l0,0c0-0.8,0-2.4,1.6-2.4l15.2-4c0.8,0,2.4,0,2.4,1.6l0,0
                    c0,0.8,0,2.4-1.6,2.4L457.6,185.6z"/>
                <path fill="#FFDCC5" d="M22.4,302.4c-0.8,0-2.4,0-2.4-1.6l0,0c0-0.8,0-2.4,1.6-2.4l15.2-4c0.8,0,2.4,0,2.4,1.6l0,0
                    c0,0.8,0,2.4-1.6,2.4L22.4,302.4z"/>
                <path fill="#FFDCC5" d="M292.8,246.4c12-11.2,18.4-26.4,18.4-43.2c0-29.6-21.6-60.8-69.6-60.8c-25.6,0-48,9.6-59.2,17.6
                    c-5.6,4-8,11.2-5.6,17.6l6.4,18.4c1.6,4.8,5.6,8,9.6,9.6c4.8,1.6,9.6,0.8,13.6-2.4c6.4-4.8,18.4-9.6,28.8-9.6
                    c17.6,0,17.6,9.6,17.6,13.6c0,13.6-20,16.8-27.2,16.8h-14.4c-8.8,0-15.2,7.2-15.2,15.2v19.2c0,8.8,7.2,15.2,15.2,15.2h14.4
                    c8,0,33.6,1.6,33.6,23.2c0,2.4,0,8.8-5.6,14.4s-15.2,7.2-22.4,7.2c-13.6,0-28-5.6-33.6-9.6c-4-2.4-8.8-3.2-13.6-1.6s-8,4.8-9.6,9.6
                    l-7.2,20c-2.4,6.4,0,14.4,6.4,18.4c11.2,7.2,32.8,15.2,57.6,15.2c58.4,0,84.8-37.6,84.8-72.8C318.4,276.8,308.8,258.4,292.8,246.4z
                    "/>
            <path fill="#F7C6A4" d="M212.8,274.4h14.4c8,0,33.6,1.6,33.6,23.2c0,2.4,0,8.8-5.6,14.4s-15.2,7.2-22.4,7.2
                c-13.6,0-28-5.6-33.6-9.6c-4-2.4-8.8-3.2-13.6-1.6s-8,4.8-9.6,9.6l-7.2,20c-2.4,6.4,0,14.4,6.4,18.4c11.2,7.2,32.8,15.2,57.6,15.2
                c58.4,0,84.8-37.6,84.8-72.8c0-20.8-9.6-39.2-25.6-51.2c12-11.2,18.4-26.4,18.4-43.2c0-8-1.6-15.2-4.8-22.4L212.8,274.4L212.8,274.4
                z"/>
            <path fill="#CC7E48" d="M218.4,88.8c0,7.2-6.4,19.2-13.6,19.2c-7.2,0-13.6-12-13.6-19.2s6.4-13.6,13.6-13.6
                C212,75.2,218.4,81.6,218.4,88.8z"/>
            <circle fill="#F7C6A4" cx="204.8" cy="88.8" r="13.6"/>
            <path fill="#E8B18B" d="M214.4,79.2c5.6,5.6,5.6,13.6,0,19.2s-13.6,5.6-19.2,0"/>
            <path fill="#CC7E48" d="M260.8,88.8c0,7.2-6.4,19.2-13.6,19.2s-13.6-12-13.6-19.2s6.4-13.6,13.6-13.6S260.8,81.6,260.8,88.8z
                "/>
            <circle fill="#F7C6A4" cx="247.2" cy="88.8" r="13.6"/>
            <path fill="#E8B18B" d="M256.8,79.2c5.6,5.6,5.6,13.6,0,19.2s-13.6,5.6-19.2,0"/>
            <path fill="#CC7E48" d="M303.2,88.8c0,7.2-6.4,19.2-13.6,19.2S276,96,276,88.8s6.4-13.6,13.6-13.6
                C296.8,75.2,303.2,81.6,303.2,88.8z"/>
            <circle fill="#F7C6A4" cx="289.6" cy="88.8" r="13.6"/>
            <path fill="#E8B18B" d="M299.2,79.2c5.6,5.6,5.6,13.6,0,19.2s-13.6,5.6-19.2,0"/>
        </svg>
    );
}

export function Emphasis({show}) {
    return (
        <div style={{display:show ? "inline":"none", animation: "celebrateFrames 1s linear 0s infinite alternate", opacity:1, position:"absolute", top:"0px", left:"0px", width:"100%", height:"100%", backgroundColor:"yellow"}}/>
    );
}
